import React from "react";
import { styled } from "@mui/system";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import Popper from "@vapor/react-material/Popper";
import { PopperProps } from "@vapor/react-material/Popper";

export const StyledAutocompletePopper = styled(
  (props) => <Popper {...props} open={true}></Popper>,
  {
    name: "StyledAutocompletePopper",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "width",
    overridesResolver: (props, styles) => []
  }
)<{ width: any }>(({ theme, width }) => ({
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: "none",
    margin: "0px",
    color: "inherit",
    borderRadius: 0,
    width: width,
    marginLeft: "-16px",
    marginTop: "10px",
    maxHeight: "444px"
  },
  [`& .${autocompleteClasses.listbox}`]: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.surfaceDefault,
    paddingTop: "8px",
    paddingBottom: "8px",
    width: width,
    maxHeight: "230px",
    overflowX: "hidden",
    [`& .${autocompleteClasses.option}`]: {
      ...theme.typography["body"],
      minHeight: "auto",
      alignItems: "flex-start",
      padding: "10px 16px",
      width: width,
      '&[aria-selected="true"]': {
        backgroundColor: "transparent",
        "& .MuiTypography-root": {
          color: "#21282B"
        }
      },
      '&[data-focus="true"], &[data-focus="true"][aria-selected="true"]': {
        backgroundColor: theme.palette.action.hover
      }
    }
  },
  [`& .${autocompleteClasses.popperDisablePortal}`]: {
    position: "relative"
  }
}));

export type StyledPopperProps = {
  children?: React.ReactNode;
  width?: any;
  onClickAway?: Function;
} & PopperProps;

export const StyledPopper = styled(
  React.forwardRef((props: StyledPopperProps, ref: any) => (
    <Popper {...props} ref={ref}></Popper>
  )),
  {
    name: "StyledPopper",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "width"
  }
)<{ width?: any }>(({ theme, width }) => ({
  border: `1px solid ${theme.palette.primary.borderDefault}`,
  boxShadow: "0 8px 24px rgba(149, 157, 165, 0.2)",
  borderRadius: 0,
  width: width,
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.surfaceDefault
}));
